/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Switch, Redirect } from 'react-router';
// material
// pages
import MasterAdsTxt from 'apps/sspadstxt/pages/adstxt/masteradstxt/masteradstxt_container';

// utils
import { PrivateRoute } from '@insticator/insticator-ui'; // iui-utils

/* ========== ~~~~~~~~~~ SSP / ADS.TXT ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
export default () => (
    <Switch>
        {/*Routes to subsections*/}
        <PrivateRoute path='/apps/sspadstxt/adstxt/masteradstxt' component={MasterAdsTxt} permitted={true} redirectTo={'/apps'} />
        <Redirect to='/error/404' />
    </Switch>
)


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
